import { Component, OnInit } from '@angular/core';
import { INFO_DATOS_BD_STATE_TOKEN as CONTAINER_STATE_TOKEN } from '../../store/states/info-datos.state';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { InfoDatosContainerModel } from '../../store/info-datos.model';
import { InfoDatosBdContainerActions as ContainerActions } from '../../store/info-datos.actions';
@Component({
  selector: 'app-section-bandeja-datos',
  templateUrl: './section-bandeja-datos.component.html',
  styleUrls: ['./section-bandeja-datos.component.scss']
})
export class SectionBandejaDatosComponent implements OnInit {

  @Select(CONTAINER_STATE_TOKEN) state$: Observable<InfoDatosContainerModel>;
  constructor(private store: Store,) { }

  ngOnInit(): void {
  }

  eliminarFormato = (data) => {
    this.store.dispatch(new ContainerActions.EliminarArchivoDescarga({
      item: {
        tipo: data.tipo,
        periodo: data.periodo,
        id: "",
        formato: ""
      }
    }));
  }

  descarga = () => {
    this.store.dispatch(new ContainerActions.DescargarZip());
  }

}
